'use strict';

(function (angular) {
  angular.module('zp').controller('LoginController', loginController);

  /**@ngInject */
  function loginController($timeout, authService, $uibModalInstance, options) {
    var vm = this;

    vm.login = {
      email: null,
      password: null
    };
    vm.register = {
      name: null,
      email: null,
      password: null
    };
    vm.loginInProgress = false;
    vm.registerInProgress = false;
    vm.loginError = false;
    vm.registrationError = false;
    vm.registrationErrorEmailAlreadyExists = false;
    vm.text = options.text;

    vm.rermoveLoginError = rermoveLoginError;
    vm.rermoveRegistrationError = rermoveRegistrationError;
    vm.doLogin = doLogin;
    vm.doRegister = doRegister;

    function doLogin() {
      vm.loginInProgress = true;
      authService.login(vm.login.email, vm.login.password).then(function (user) {
        vm.loginInProgress = false;
        $uibModalInstance.close(user);
      }).catch(function () {
        vm.loginError = true;
        vm.loginInProgress = false;
      });
    }

    function doRegister() {
      vm.registerInProgress = true;
      authService.register(vm.register.email, vm.register.password, vm.register.name).then(function (user) {
        vm.registerInProgress = false;
        $uibModalInstance.close(user);
      }).catch(function () {
        vm.loginError = true;
        vm.registerInProgress = false;
      });
    }

    function rermoveLoginError() {
      vm.loginError = false;
    }

    function rermoveRegistrationError() {
      vm.registrationError = false;
      vm.registrationErrorEmailAlreadyExists = false;
    }

    function loginValid() {
      return vm.login.email && vm.login.phone;
    }

    function registrationValid() {
      return vm.register.email && vm.register.phone && vm.register.street && vm.register.streetNumber && vm.register.firstName && vm.register.lastName;
    }
  }
})(window.angular);